module.exports = __webpack_public_path__ + "img/89823918003755.95f131e6.png";